import { render } from "./proList.vue?vue&type=template&id=53d05168&scoped=true"
import script from "./proList.vue?vue&type=script&lang=js"
export * from "./proList.vue?vue&type=script&lang=js"

import "./proList.vue?vue&type=style&index=0&id=53d05168&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d05168"]])

export default __exports__